import React from 'react';
import styled from 'styled-components';
import SectionHeading from '../../components/common/SectionHeading';

const Wrapper = styled.section`
  background: ${({ theme }) => theme.colors.surface};
  border-radius: 1.5rem;
  padding: 2.5rem;
  box-shadow: ${({ theme }) => theme.shadows.md};
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 2rem 0 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.5rem;
`;

const ListItem = styled.li`
  border-radius: 1rem;
  padding: 1.5rem;
  background: ${({ theme }) => theme.colors.surfaceMuted};
`;

const ItemTitle = styled.h3`
  margin: 0 0 0.5rem;
  font-family: ${({ theme }) => theme.fonts.heading};
`;

const ItemDescription = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.textMuted};
`;

const SubPageTemplate = ({ eyebrow, title, description, items = [] }) => (
  <Wrapper>
    <SectionHeading eyebrow={eyebrow} title={title} description={description} />
    <List>
      {items.map((item) => (
        <ListItem key={item.title}>
          <ItemTitle>{item.title}</ItemTitle>
          <ItemDescription>{item.description}</ItemDescription>
        </ListItem>
      ))}
    </List>
  </Wrapper>
);

export default SubPageTemplate;


